import type { StrapiMagazineArticleCategory } from '~/composables/types/strapi/strapi-magazine'

const STATE_KEY = 'magazineCategoryData'

export const useMagazineCategoryStore = () => {
  const data = useState<StrapiMagazineArticleCategory | null>(
    STATE_KEY,
    () => null
  )

  const set = (value: StrapiMagazineArticleCategory | null) => {
    data.value = value
  }

  const clearIfOwner = (ownedValue: StrapiMagazineArticleCategory | null) => {
    if (data.value === ownedValue) {
      data.value = null
    }
  }

  return {
    data,
    set,
    clearIfOwner,
  }
}
